/* eslint-disable */
const HotelCategoryEntity = Backbone.Model.extend({
	defaults: {
		id: null,
		name: null,
		stars: null
	}
});

export default HotelCategoryEntity;